import * as React from "react";
const SvgFiRrAuction = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-auction_svg__a)">
      <path
        fill="#062147"
        d="m14.696 15.381-.81.81a.999.999 0 1 0 1.414 1.413l7.402-7.4a.999.999 0 1 0-1.414-1.415l-.722.722-7.082-7.082.722-.722A1 1 0 1 0 12.792.293L5.39 7.695A.999.999 0 1 0 6.804 9.11l.81-.81 2.836 2.836L.293 21.293a.999.999 0 1 0 1.414 1.414L11.865 12.55l2.832 2.831zm4.457-4.456-3.043 3.042-1.245-1.245 3.043-3.043zm-8.789-2.703L9.028 6.886l3.043-3.043 1.336 1.336zm4.457-1.629 1.672 1.672-3.043 3.043-1.672-1.672zM24.001 23a1 1 0 0 1-1 1H10a1 1 0 1 1 0-2h.05c.232-1.14 1.242-2 2.45-2h8c1.207 0 2.216.86 2.448 2H23a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-auction_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAuction;
